import api from "@/lib/api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

// Subscribe this device to Web Push and register it with the backend.
export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  if (!data.publicKey) throw new Error("no-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.publicKey),
    });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return true;
}

// Send the computed upcoming reminder timestamps to the backend to dispatch in the background.
// `kind` ("prayer" | "manasik") lets each feature replace only its own reminders.
export async function scheduleReminders(reminders, kind = "prayer") {
  const clean = reminders.map(({ send_at, title, body, url }) => ({ send_at, title, body, url }));
  const { data } = await api.post("/push/reminders", { reminders: clean, kind });
  return data;
}

export const listReminders = (kind) => api.get(`/push/reminders?kind=${kind}`).then((r) => r.data.reminders);
